var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238 56",
    fill: "none",
    role: "img",
    "aria-label": "SecuCenter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 8 L8 8 L8 28 L48 28 L48 48 L8 48",
    stroke: "#e2e8f0",
    strokeWidth: 5.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 8,
    r: 4.5,
    fill: "#60a5fa"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 4.5,
    fill: "#60a5fa"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 28,
    r: 4.5,
    fill: "#60a5fa"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 28,
    r: 4.5,
    fill: "#60a5fa"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 4.5,
    fill: "#60a5fa"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 48,
    r: 4.5,
    fill: "#60a5fa"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 12,
    x2: 66,
    y2: 44,
    stroke: "#475569",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 35,
    fontFamily: "'Segoe UI', Inter, -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: -0.3,
    fill: "#e2e8f0"
  }, "Secu", /*#__PURE__*/React.createElement("tspan", {
    fill: "#60a5fa"
  }, "Center"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuLogoDark);
export default __webpack_public_path__ + "static/media/secu-logo-dark.b102470332b846d45dfa6d3d20acb210.svg";
export { ForwardRef as ReactComponent };